import Immutable from 'immutable';
import { createSelector } from 'reselect';

export const getBibEntities = createSelector(
  [state => state.getIn(['entities', 'bibs'], Immutable.Map())],
  bibs => bibs
);
export const getCatalogBibEntities = createSelector(
  [state => state.getIn(['entities', 'catalogBibs'], Immutable.Map())],
  bibs => bibs
);
export const getReviewEntities = createSelector(
  [state => state.getIn(['entities', 'reviews'], Immutable.Map())],
  bibs => bibs
);
export const getListEntities = createSelector(
  [state => state.getIn(['entities', 'lists'], Immutable.Map())],
  bibs => bibs
);
export const getUserEntities = createSelector(
  [state => state.getIn(['entities', 'users'], Immutable.Map())],
  bibs => bibs
);
export const getAuthorNoteEntities = createSelector(
  [state => state.getIn(['entities', 'authorNotes'], Immutable.Map())],
  bibs => bibs
);
export const getAuthorSuggestionEntities = createSelector(
  [state => state.getIn(['entities', 'authorSuggestions'], Immutable.Map())],
  bibs => bibs
);
export const getBibItemEntities = createSelector(
  [state => state.getIn(['entities', 'bibItems'], Immutable.Map())],
  bibItems => bibItems
);
export const getAvailabilityEntities = createSelector(
  [state => state.getIn(['entities', 'availabilities'], Immutable.Map())],
  bibItems => bibItems
);
export const getSubscriptionEntities = createSelector(
  [state => state.getIn(['entities', 'subscriptions'], Immutable.Map())],
  subscriptions => subscriptions
);
export const getRelatedAuthorEntities = createSelector(
  [state => state.getIn(['entities', 'relatedAuthors'], Immutable.Map())],
  bibs => bibs
);
export const getSeriesEntryEntities = createSelector(
  [state => state.getIn(['entities', 'seriesEntries'], Immutable.Map())],
  bibs => bibs
);
export const getMediaSummaryEntities = createSelector(
  [state => state.getIn(['entities', 'mediaSummaries'], Immutable.Map())],
  mediaSummaries => mediaSummaries
);
export const getExcerptEntities = createSelector(
  [state => state.getIn(['entities', 'excerpts'], Immutable.Map())],
  excerpts => excerpts
);
export const getMarcFieldEntities = createSelector(
  [state => state.getIn(['entities', 'marcFields'], Immutable.Map())],
  marcFields => marcFields
);

// UGC
export const getCommentEntities = createSelector(
  [state => state.getIn(['entities', 'ugc', 'comments'], Immutable.Map())],
  bibs => bibs
);

export const getQuotationEntities = createSelector(
  [state => state.getIn(['entities', 'ugc', 'quotations'], Immutable.Map())],
  bibs => bibs
);

export const getIOwnThisEntities = createSelector(
  [state => state.getIn(['entities', 'ugc', 'iOwnThis'], Immutable.Map())],
  bibs => bibs
);

export const getSummaryEntities = createSelector(
  [state => state.getIn(['entities', 'ugc', 'summaries'], Immutable.Map())],
  bibs => bibs
);

export const getFlagEntities = createSelector(
  [state => state.getIn(['entities', 'ugc', 'flags'], Immutable.Map())],
  bibs => bibs
);

export const getLikeEntities = createSelector(
  [state => state.getIn(['entities', 'ugc', 'likes'], Immutable.Map())],
  bibs => bibs
);

export const getHoldableItemEntities = createSelector(
  [state => state.getIn(['entities', 'holdableItems'], Immutable.Map())],
  holdableItems => holdableItems
);

export const getEventEntities = createSelector(
  [state => state.getIn(['entities', 'events'], Immutable.Map())],
  events => events
);

export const getEventAudienceEntities = createSelector(
  [state => state.getIn(['entities', 'eventAudiences'], Immutable.Map())],
  eventAudiences => eventAudiences
);

export const getEventTypesEntities = createSelector(
  [state => state.getIn(['entities', 'eventTypes'], Immutable.Map())],
  eventTypes => eventTypes
);

export const getEventProgramsEntities = createSelector(
  [state => state.getIn(['entities', 'eventPrograms'], Immutable.Map())],
  eventPrograms => eventPrograms
);

export const getEventLanguagesEntities = createSelector(
  [state => state.getIn(['entities', 'eventLanguages'], Immutable.Map())],
  eventLanguages => eventLanguages
);

export const getLocationEntities = createSelector(
  [state => state.getIn(['entities', 'locations'], Immutable.Map())],
  locations => locations
);

export const getPlaceEntities = createSelector(
  [state => state.getIn(['entities', 'places'], Immutable.Map())],
  places => places
);

export const getImageEntities = createSelector(
  [state => state.getIn(['entities', 'images'], Immutable.Map())],
  images => images
);

export const getCardEntities = createSelector(
  [state => state.getIn(['entities', 'cards'], Immutable.Map())],
  cards => cards
);

export const getPromoEntities = createSelector(
  [state => state.getIn(['entities', 'promos'], Immutable.Map())],
  promos => promos
);

export const getLibraryEntities = createSelector(
  [state => state.getIn(['entities', 'libraries'], Immutable.Map())],
  libraries => libraries
);
